import React from "react";
import Marquee from "react-fast-marquee";
import { Reveal } from "../Reveal";
import { Quote } from "lucide-react";

export const Testimonials = ({ data }) => {
  const testimonials = data?.testimonials || [];

  return (
    <section
      id="testimonials"
      className="relative bg-[#0a0a0a] py-16 md:py-24 overflow-hidden"
      data-testid="testimonials-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal className="mb-12 flex items-center gap-4">
          <span className="h-px w-12 bg-gold" />
          <span className="text-gold text-xs uppercase tracking-[0.3em]">Kind Words</span>
        </Reveal>
      </div>

      <Marquee speed={45} gradient={false} pauseOnHover autoFill>
        {testimonials.map((t) => (
          <figure
            key={t.id}
            className="group mx-3 flex h-full w-[340px] md:w-[420px] flex-col justify-between rounded-xl border border-line bg-surface p-8 transition-colors duration-500 hover:border-gold/40"
            data-testid={`testimonial-${t.id}`}
          >
            <div>
              <Quote className="text-coral mb-6" size={32} />
              <blockquote className="font-display text-xl md:text-2xl leading-snug text-ink italic">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
            </div>
            <figcaption className="mt-8 border-t border-line pt-5">
              <div className="text-gold font-medium">{t.author}</div>
              <div className="text-smoke text-sm">{t.role}</div>
            </figcaption>
          </figure>
        ))}
      </Marquee>
    </section>
  );
};
